<section *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formStockMaxMin">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button type="button" [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)=" deleteStockMaxMin()"></app-custom-button>

              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewStockMaxMin()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="stockMaxMinContract.userNameCreate"
                [createDate]="stockMaxMinContract.createDate" [userNameUpdate]="stockMaxMinContract.userNameUpdate"
                [updateDate]="stockMaxMinContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <!-- Formulario Captura -->
          <div class="row">
            <div class="col-lg-12 col-12">
              <div class="row">
                <div class="col-lg-2 col-md-3 col-sm-4 col-12">
                  <app-custom-select formControlName="inventoryId" [labelText]="'Inventario'" [list]="listInventories"
                    [required]="true" [recovery]="true"
                    (onChangeSelect)="getInventory($event, true)"></app-custom-select>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-4 col-12">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                    [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event, true)"></app-custom-select>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-4 col-12">
                  <app-custom-select formControlName="storeId" [labelText]="'Bodega'" [list]="listStores"
                    [required]="true" [recovery]="true" (onChangeSelect)="getStore($event, true)"></app-custom-select>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-4 col-12">
                  <app-custom-autocomplete formControlName="articleId" [labelText]="'Artículo'" [list]="listArticles"
                    [required]="true" [recovery]="true" [showExtraButton]="true"
                    [titleExtraButton]="'Seleccionar Artículo'" [iconExtraButton]="'pi pi-external-link'"
                    (clickExtraButton)="openArticleSelectionModal()" (onChangeSelect)="getArticle($event, true)">
                  </app-custom-autocomplete>
                  <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Selección de Artículo'"
                    [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
                    (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
                </div>
                <div class="col-lg-1 col-md-4 col-sm-4 col-4">
                  <app-custom-input-decimal formControlName="stockMin" [required]="true"
                    [labelText]="'Tope Mín.'"></app-custom-input-decimal>
                </div>
                <div class="col-lg-1 col-md-4 col-sm-4 col-4">
                  <app-custom-input-decimal formControlName="stockMax" [required]="true"
                    [labelText]="'Tope Máx.'"></app-custom-input-decimal>
                </div>

                <div class="col-lg-1 col-md-3 col-sm-4 col-12">
                  <app-custom-input-text formControlName="storeLocation" [labelText]="'Ubicación Bodega'"
                    [maxLength]="50">
                  </app-custom-input-text>
                </div>
                <div class="col-lg-1 col-md-2 col-sm-2 col-12 d-flex justify-content-center align-items-end">
                  <app-custom-button [disabled]="disabledForm" [label]="'Guardar'" [severity]="'primary'"
                    [variant]="undefined" (onClick)="send()"></app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>